import { TableCell, TableRow } from "@mui/material"
import { getRuleImpactLabel } from "./rule-impact-label"

export function CostFrequencyModifierRow({ item }) {
    const multiplier = Number(item.frequencyMultiplier) || 1
    const pct = Math.round((multiplier - 1) * 100)
    const sign = pct >= 0 ? "+" : ""
    return (
        <TableRow data-cy="frequency-modifier-row">
            <TableCell>{getRuleImpactLabel(item)}</TableCell>
            <TableCell align="right">{item.taskCount}</TableCell>
            <TableCell align="right">{`${sign}${pct}% (${multiplier.toFixed(2)}x)`}</TableCell>
        </TableRow>
    )
}
